import React, { FC } from 'react';
import { CommonStoreProvider, StoreHandler } from '@dew21/ui';

export const CommonStoreHandler: StoreHandler = {
	set: (key, value) => {
		try {
			if (value) {
				sessionStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
			} else {
				sessionStorage.removeItem(key);
			}
		} catch (err) {
			//
		}
	},
	get: (key) => {
		const item = sessionStorage.getItem(key);
		try {
			if (item) {
				const parsed = JSON.parse(item);
				if (parsed) {
					return parsed;
				}
			}
		} catch (err) {
			//
		}
		return item;
	},
	clear: (key) => {
		try {
			sessionStorage.removeItem(key);
		} catch (err) {
			//
		}
	}
};

export const CommonStoreHandlerProvider: FC = ({ children }) => {
	return (
		<CommonStoreProvider storeHandler={CommonStoreHandler}>
			{children}
		</CommonStoreProvider>
	)
}